export default class AutoSeatButton {
    constructor(props, buttonSelector) {
        this.props = props;
        this.button = $(buttonSelector);
        this.dataStorage = this.props.dataStorage;

        this.button.on('click', async (evt) => {
            this.props._showLoader();
            const eventId = this.button.data('event-id');
            const response = await fetch(`/Seating/AutoSeatForCart/${eventId}`);
            this.props._hideLoader();
            if (response.ok) {
                const result = await response.json();
                if (!result.success) {
                    console.error('ERROR', result.message);
                    return;
                }
                this.dataStorage.cart = result.data.cartItems;
                const startEvent = new Event("cartUpdateEvent");
                document.dispatchEvent(startEvent);

                this.props.reloadCart();
                // Ensure NextArenaEvent button is updated after auto seat
                if (typeof this.props._updateNextArenaEventButton === 'function') {
                    this.props._updateNextArenaEventButton();
                } else if (this.props._updateUI) {
                    this.props._updateUI();
                }
            }
        });
    }
}
